const storageKey = 'devarch-theme';
const root = document.documentElement;

function getTheme() {
  return root.dataset.devarchTheme === 'light' ? 'light' : 'dark';
}

function updateButtons() {
  const theme = getTheme();
  const label = theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme';

  document.querySelectorAll('[data-devarch-theme-toggle]').forEach((button) => {
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
    button.setAttribute('aria-pressed', String(theme === 'light'));
  });
}

function setTheme(theme, persist = true) {
  const nextTheme = theme === 'light' ? 'light' : 'dark';
  root.dataset.devarchTheme = nextTheme;
  root.style.colorScheme = nextTheme;

  if (persist) {
    try {
      localStorage.setItem(storageKey, nextTheme);
    } catch {
      // The selected theme still applies when browser storage is unavailable.
    }
  }

  updateButtons();
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-devarch-theme-toggle]');
  if (!button) return;

  setTheme(getTheme() === 'dark' ? 'light' : 'dark');
});

document.addEventListener('shopify:section:load', updateButtons);

window.addEventListener('storage', (event) => {
  if (event.key === storageKey && (event.newValue === 'dark' || event.newValue === 'light')) {
    setTheme(event.newValue, false);
  } else if (event.key === storageKey && event.newValue === null) {
    setTheme('dark', false);
  }
});

updateButtons();
